const actionType = 'BILLING_PAYMENT';
const actions = {
	createType: `${actionType}_CREATE`,
	create: ({ method, amount, stage, cvv }) => ({
		type: `${actionType}_CREATE`,
		method,
		amount,
		stage,
		cvv,
	}),
	confirmType: `${actionType}_CONFIRM`,
	confirm: ({ method, amount, cvv, onSuccess = () => {} }) => ({
		type: `${actionType}_CONFIRM`,
		method,
		amount,
		cvv,
		onSuccess,
	}),
	setStageType: `${actionType}_STAGE_SET`,
	setStage: ({ stage }) => ({
		type: `${actionType}_STAGE_SET`,
		stage,
	}),
	fetchPayPalType: `${actionType}_PAYPAL_FETCH`,
	fetchPayPal: ({ id }) => ({
		type: `${actionType}_PAYPAL_FETCH`,
		id,
	}),
	BILLING_PAYMENT_METHOD_INIT: 'BILLING_PAYMENT_METHOD_INIT',
	init: () => ({
		type: actions.BILLING_PAYMENT_METHOD_INIT,
	}),
	BILLING_PAYMENT_HAS_METHOD_CHECK: 'BILLING_PAYMENT_HAS_METHOD_CHECK',
	hasPaymentMethodCheck: ({ navigate } = {}) => ({
		type: actions.BILLING_PAYMENT_HAS_METHOD_CHECK,
		navigate,
	}),
};

export default actions;
